export default {
  createGroup: 'Crear Grupo',
  creatingGroup: 'Creando grupo...',
  newGroup: 'Nuevo Grupo',
  name: 'Nombre',
  required: 'Requerido',
  create: 'Crear',
  search: 'Buscar',
  manageGroupUsers: 'Administrar usuarios del grupo',
  manageGroupModels: 'Administrar modelos del grupo',
  manageGroupReferences: 'Administrar referencias del grupo',
  manageGroupEkrms: 'Administrar EKRMs del grupo',
  deleteGroup: 'Eliminar grupo',
  warning: 'Advertencia',
  deletingGroup: 'Eliminando grupo:',
  cannotBeUndone: 'Esta acción no se puede deshacer. ¿Estás seguro?',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  usersForGroup: 'Usuarios del grupo:',
  modelsForGroup: 'Modelos del grupo:',
  referencesForGroup: 'Referencias del grupo:',
  ekrmsForGroup: 'EKRMs del grupo:',
  save: 'Guardar',
  abort: 'Abortar',
  confirm: 'Confirmar',
  processing: 'Procesando...',
  userHeader: 'Usuario',
  modelHeader: 'Modelo',
  typeHeader: 'Tipo',
  createdHeader: 'Creado',
  referenceHeader: 'Referencia',
  ekrmHeader: 'EKRM',
  adHoc: 'Ad-Hoc',
  custom: 'Personalizado',
  nameAlreadyUsed: 'Nombre ya utilizado'
}
